import { BaseBody } from '../BaseBody.js';
import { CssVars } from '../../../util/CssVars.js';

const glyphname = 'modeNi';
const args = {};

export class ModeNi extends BaseBody {
  constructor() {
    super(glyphname, args);
  }
}
